<script>
import atshq from "../js/setup";
export default {
  data() {
    return {};
  },

  created() {
    window.open(atshq.defaults.headers.common.app_URL + "index.php/auth/logout");
    localStorage.setItem("token", "");
    localStorage.setItem("userId", "");
    localStorage.setItem("userName", "");
    localStorage.setItem("specialPower", "");
    window.location.href = "/";
  },
};
</script>